import { withCallbacks, signalMiddleware } from "redux-signalr";
import {
  JsonHubProtocol,
  HttpTransportType,
  HubConnectionBuilder,
  LogLevel
} from "@microsoft/signalr"; // version 1.0.4
import getConfig from "../app/config";
import auth from "../shared/auth";
import { fetchScenesShootingOrder } from "../films/shooting-days/shooting-order/ducks/actions";
import { fetchShootingDays } from "../films/shooting-days/ducks/actions";
import { showInfo, clearNotifications } from "../notifications/ducks/actions";

let config = getConfig();
const urlRoot = config.apiUrl;
let url = urlRoot.substring(0, urlRoot.length - 1);
var to = url.lastIndexOf("/");
to = to == -1 ? url.length : to + 1;
url = url.substring(0, to);
const connectionHub = url + `schedulinghub`;

const protocol = new JsonHubProtocol();

// let transport to fall back to to LongPolling if it needs to
const transport =
  HttpTransportType.WebSockets | HttpTransportType.LongPolling;

const options = {
  transport,
  logMessageContent: true,
  logger: LogLevel.Error,
  accessTokenFactory: () => auth.getSignalRToken()
};

// create the connection instance
export const connection = new HubConnectionBuilder()
  .withUrl(connectionHub, options)
  .withHubProtocol(protocol)
  .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
  .build();

// Handle reconnection events
connection.onreconnecting((error) => {
  console.warn('SignalR connection lost. Reconnecting...', error);
});

connection.onreconnected((connectionId) => {
  console.log('SignalR reconnected. Connection ID:', connectionId);
  // Re-subscribe to film if we were subscribed before
  if (currentFilmId) {
    connection.invoke('SubscribeToFilm', currentFilmId).catch(err => {
      console.error('Failed to re-subscribe to film after reconnect:', err);
    });
  }
});

connection.onclose((error) => {
  console.error('SignalR connection closed:', error);
});

export const SCHEDULING_PROGRESS = "SCHEDULING_PROGRESS";
export const SCHEDULING_COMPLETED = "SCHEDULING_COMPLETED";
export const SCHEDULING_ERROR = "SCHEDULING_ERROR";

// Store the current filmId for SignalR callbacks
let currentFilmId: number | null = null;

export const setCurrentFilmId = (filmId: number) => {
  currentFilmId = filmId;
};

const callbacks = withCallbacks()
  .add('ScheduleProgress', (progress, message) => (dispatch) => {
    dispatch({
      type: SCHEDULING_PROGRESS,
      meta: { progress, message }
    });
  })
  .add('ScheduleComplete', () => (dispatch) => {
    dispatch({
      type: SCHEDULING_COMPLETED,
      meta: {}
    });

    // Use stored filmId from subscription
    if (currentFilmId) {
      dispatch(fetchScenesShootingOrder(currentFilmId));
      dispatch(fetchShootingDays(currentFilmId));
      dispatch(showInfo("Schedule created successfully!"));
      dispatch(clearNotifications());
    } else {
      console.error("ScheduleComplete: filmId not available");
    }
  })
  .add('ScheduleError', (errorMessage) => (dispatch) => {
    dispatch({
      type: SCHEDULING_ERROR,
      meta: { errorMessage }
    });
  });


export const signal = signalMiddleware({
  callbacks,
  connection,
  shouldConnectionStartImmediately: false
});

